import * as selectors from './selectors'

export const ftListSelectors = selectors
